/**
 * REV-21353 — FE-Contract der Mandats-Navigation (Pure View).
 * Aus dem AWF-Prototyp abgeleitet. Kein Backend-Contract — die Modul-/Schritt-Daten
 * kommen von der (NgRx-)Smart-Komponente rein, dieser View bleibt dumm.
 */

/**
 * Status-Marker eines Abschluss-Schritts (Entscheid REV-21353): genau drei Zustände aus dem
 * Prototyp — 'done' (✓), 'open' (○), 'none' (—). BEWUSST eigenständig, NICHT ans
 * Shared-Kernel-Statusset (8 Konto-Status) gekoppelt. Der Marker ist ein Roll-up PRO SCHRITT,
 * nicht der Konto-Status pro Konto (den rechnet der Container und übergibt das Roll-up als Input).
 */
export type NavStepStatus = 'done' | 'open' | 'none';

export interface NavStep {
    /** Stabiler Key = Routing-/Selektions-Ziel, z. B. 'abstimmung-bilanzkonten'. */
    id: string;
    label: string;
    status: NavStepStatus;
    /**
     * Optional (REV-22479). A locked step shows greyed out and cannot be clicked; `lockedReason`
     * says why, as its tooltip. Without it the step looks and behaves as before.
     */
    locked?: boolean;
    lockedReason?: string;
}

export interface NavModule {
    /** Stabiler Key, z. B. 'jahresabschluss'. */
    id: string;
    label: string;
    /** Icon-Key (hamIcons). TODO(REV-21353): gegen vorhandene Assets bestätigen. */
    icon: string;
    /** Nur bei Modulen mit Unterschritten (im Prototyp: Jahresabschluss). */
    steps?: NavStep[];
    /** Optional. Without it the row looks and behaves as before. */
    action?: NavModuleAction;
}

/** An icon button beside a module row — e.g. the module's settings. */
export interface NavModuleAction {
    /** Path of a hamIcons SVG, e.g. `assets/hamIcons/settings-wheel.svg`. */
    icon: string;
    /** For screen readers; the button shows only the icon. */
    label: string;
}

export interface NavMandateContext {
    mandantName: string;
    fiscalYearLabel: string;
}
